import {FC} from 'react'
import {ProjectSmall} from '@/features/projects/types.ts'
import {StyledStatusBullet} from '@/features/projects/components/status-bullet/style.ts'

export const StatusBullet: FC<{status: ProjectSmall['status']}> = ({status}) => <StyledStatusBullet $status={status} />
